import { supabase, DoctorHoliday } from '../lib/supabase';
import { getTenantId } from '../contexts/TenantContext';

export const doctorHolidayService = {
  async getAll(): Promise<DoctorHoliday[]> {
    const tenantId = getTenantId();
    const { data, error } = await supabase
      .from('doctor_holidays')
      .select(`
        *,
        doctor:doctors(*)
      `)
      .eq('tenant_id', tenantId)
      .is('deleted_at', null)
      .order('start_date', { ascending: false });

    if (error) throw error;
    return data || [];
  },

  async getByDoctorId(doctorId: string): Promise<DoctorHoliday[]> {
    const tenantId = getTenantId();
    const { data, error } = await supabase
      .from('doctor_holidays')
      .select(`
        *,
        doctor:doctors(*)
      `)
      .eq('tenant_id', tenantId)
      .eq('doctor_id', doctorId)
      .eq('status', 'active')
      .is('deleted_at', null)
      .order('start_date', { ascending: false });

    if (error) throw error;
    return data || [];
  },

  async getUpcoming(): Promise<DoctorHoliday[]> {
    const tenantId = getTenantId();
    const today = new Date().toISOString().split('T')[0];
    const { data, error } = await supabase
      .from('doctor_holidays')
      .select(`
        *,
        doctor:doctors(*)
      `)
      .eq('tenant_id', tenantId)
      .gte('end_date', today)
      .eq('status', 'active')
      .is('deleted_at', null)
      .order('start_date', { ascending: true });

    if (error) throw error;
    return data || [];
  },

  async getById(id: string): Promise<DoctorHoliday | null> {
    const tenantId = getTenantId();
    const { data, error } = await supabase
      .from('doctor_holidays')
      .select(`
        *,
        doctor:doctors(*)
      `)
      .eq('id', id)
      .eq('tenant_id', tenantId)
      .is('deleted_at', null)
      .single();

    if (error) throw error;
    return data;
  },

  async create(holiday: Omit<DoctorHoliday, 'id' | 'tenant_id' | 'created_at' | 'updated_at' | 'deleted_at' | 'doctor'>): Promise<DoctorHoliday> {
    const tenantId = getTenantId();
    const { data, error } = await supabase
      .from('doctor_holidays')
      .insert({ ...holiday, tenant_id: tenantId })
      .select(`
        *,
        doctor:doctors(*)
      `)
      .single();

    if (error) throw error;
    return data;
  },

  async update(id: string, holiday: Partial<DoctorHoliday>): Promise<DoctorHoliday> {
    const tenantId = getTenantId();
    const { data, error } = await supabase
      .from('doctor_holidays')
      .update(holiday)
      .eq('id', id)
      .eq('tenant_id', tenantId)
      .select(`
        *,
        doctor:doctors(*)
      `)
      .single();

    if (error) throw error;
    return data;
  },

  async delete(id: string): Promise<void> {
    const tenantId = getTenantId();
    const { error } = await supabase
      .from('doctor_holidays')
      .update({ deleted_at: new Date().toISOString() })
      .eq('id', id)
      .eq('tenant_id', tenantId);

    if (error) throw error;
  }
};
